
import { PKState } from './state';


// mutations
export default {
  ['firstRun'](state: PKState, data) {
    // state.allNews = data;
    console.log(state);
  },
  ['allNews'](state: PKState, data) {
    state.allNews = data;
  },
  ['monthSlideset'](state: PKState, data) {
    state.monthSlideset = data;
  },
  ['frontText'](state: PKState, obj) {
    const [key, text] = [obj.key, obj.text];
    const o = state.frontText.find(a => a.key === key);
    if (!o) {
      state.frontText.push({
        key: key,
        text: text
      });
    } else {
      o.text = text;
    }
  },
  ['addArchiveEdition'](state: PKState, data) {
    if (!state.archiveEditions.find(ae => ae._id === data._id)) {
      state.archiveEditions.push(data);
    }
  },
  ['addCriticalEdition'](state: PKState, data) {
    if (!state.criticalEditions.find(ce => ce._id === data._id)) {
      state.criticalEditions.push(data);
    }
  },
  ['resetSearchResult'](state: PKState) {
    state.searchResult = [];
  },
  ['addSearchResult'](state: PKState, data) {
    state.searchResult.push(data);
  },
  ['currentSlideset'](state: PKState, data) {
    state.currentSlideset = data;
  },
  ['addDocument'](state: PKState, data) {
    state.documents.push(data);
  },
  ['dragbox-ausblenden'](state: PKState, b) {
    state.timelineToolBar[0].enable = b;
  },
  ['dragbox-einblenden'](state: PKState, b) {
    state.timelineToolBar[1].enable = b;
  },
  ['timelineToolBarEvent'](state: PKState, data) {
    state.timelineNavEvent = data + ' ' + Date.now();
  }
};
